module.exports = "/lucky-balls/img/drum/drum_loop_028.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_028.png
// module id = 1043
// module chunks = 0